import React from "react";

function Mute() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28.364"
      height="20.875"
      viewBox="0 0 28.364 20.875"
    >
      <path
        id="Path_18537"
        data-name="Path 18537"
        d="M12.123,8.085l-4.2,3.435H3.472v4.944H7.925l4.2,3.435ZM7.042,18.936H2.236A1.236,1.236,0,0,1,1,17.7V10.285A1.236,1.236,0,0,1,2.236,9.049H7.042l6.544-5.354a.618.618,0,0,1,1.009.478V23.812a.618.618,0,0,1-1.009.478Zm17.952-4.944,4.37,4.37L27.616,20.11l-4.37-4.37-4.37,4.37-1.748-1.748,4.37-4.37-4.37-4.37,1.748-1.748,4.37,4.37,4.37-4.37,1.748,1.748Z"
        transform="translate(-1 -3.555)"
        fill="#fafbfd"
      />
    </svg>
  );
}

export default Mute;
